export const types = [
  {
    iso: "wholesaler",
    name: "Hurtownia",
  },
  {
    iso: "retailer",
    name: "Sprzedawca detaliczny",
  },
  {
    iso: "garage",
    name: "Warsztat specjalistyczny",
  },
  {
    iso: "other",
    name: "Inne",
  },
];

export const customers = [
  {
    iso: "individual",
    name: "Indywidualni właściciele samochodów",
  },
  {
    iso: "retail",
    name: "Warsztaty i sprzedaż detaliczna",
  },
];

export const specialisations = [
  {
    iso: "makes",
    name: "Marki pojazdów",
  },
  {
    iso: "parts",
    name: "Tylko wybrane podzespoły",
  },
  {
    iso: "other",
    name: "Inne",
  },
];

export const areas = [
  {
    iso: "local",
    name: "Rynek lokalny",
  },
  {
    iso: "country",
    name: "Rynek krajowy",
  },
  {
    iso: "outside",
    name: "Rynek zagraniczny",
  },
];

export const willStocks = [
  {
    iso: "yes",
    name: "Tak",
  },
  {
    iso: "no",
    name: "Nie",
  },
];
